import '../chart_view.js.coffee';# Added by Script 
import './pie_chart_view.js.coffee'
Monitoring.Views.Charts ||= {}

class Monitoring.Views.Charts.UniqueUsersChartView extends Monitoring.Views.Charts.ChartView
  template: JST["backbone/templates/monitoring/charts/count_chart"]
  className: 'item unique-users-counter'

  events:
    'click .maximize': 'onMaximize'
    'click #close_chart': 'destroy'
    'click #save_note': 'saveNote'
    'click #delete_note': 'deleteNote'
    'click .insert-note': 'displayNote'

  initialize: (@options = {}) ->
    @searchQuery = @options.searchQuery
    @facets = @options.facets
    @_settings = @options.settings
    @container = @options.container
    @number = @options.container.uniqueUsersCount.toLocaleString('de-DE')

  render: () ->
    @$el.html(@template({
      title: I18n.t('monitoring.dashboard.charts.unique_users_count')
      count_number: @number

    }))
    charts_size = 576/ (@$el.find('.count-number').html().length*5) + 50
    @$el.find('.count-number').css('font-size',"#{charts_size}px")
    @trigger('masonry')
    return this

  onMaximize: (event) ->
    if $(event.target.parentElement.parentElement.parentElement).hasClass('w2')
      $(event.target.parentElement.parentElement.parentElement).removeClass('w2')
      charts_size = 576/ (@$el.find('.count-number').html().length*5) + 50
      @$el.find('.count-number').css('font-size',"#{charts_size}px")
    else
      $(event.target.parentElement.parentElement.parentElement).addClass('w2')
      charts_size = 1165 / (@$el.find('.count-number').html().length*5) + 50
      @$el.find('.count-number').css('font-size', "#{charts_size}px")
    @trigger('masonry')
    
  destroy: ->
    @$el.remove()
    @remove()
    @trigger('removeChart', @)
